/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Work_0_BadgeInputs */

const en_svc_messaging_bots_work_0_badge = /** @type {(inputs: Svc_Messaging_Bots_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat commerce automation`)
};

const ar_svc_messaging_bots_work_0_badge = /** @type {(inputs: Svc_Messaging_Bots_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أتمتة التجارة بالمحادثة`)
};

const bn_svc_messaging_bots_work_0_badge = /** @type {(inputs: Svc_Messaging_Bots_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চ্যাট বাণিজ্য অটোমেশন`)
};

const de_svc_messaging_bots_work_0_badge = /** @type {(inputs: Svc_Messaging_Bots_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat-Commerce-Automatisierung`)
};

const es_svc_messaging_bots_work_0_badge = /** @type {(inputs: Svc_Messaging_Bots_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatización de comercio por chat`)
};

const fr_svc_messaging_bots_work_0_badge = /** @type {(inputs: Svc_Messaging_Bots_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisation du commerce par chat`)
};

const pt_svc_messaging_bots_work_0_badge = /** @type {(inputs: Svc_Messaging_Bots_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automação de comércio por chat`)
};

const zh_svc_messaging_bots_work_0_badge = /** @type {(inputs: Svc_Messaging_Bots_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`聊天电商自动化`)
};

const tr_svc_messaging_bots_work_0_badge = /** @type {(inputs: Svc_Messaging_Bots_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sohbet ticareti otomasyonu`)
};

const ru_svc_messaging_bots_work_0_badge = /** @type {(inputs: Svc_Messaging_Bots_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизация chat-commerce`)
};

const pl_svc_messaging_bots_work_0_badge = /** @type {(inputs: Svc_Messaging_Bots_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatyzacja handlu przez czat`)
};

/**
* | output |
* | --- |
* | "Chat commerce automation" |
*
* @param {Svc_Messaging_Bots_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_work_0_badge = /** @type {((inputs?: Svc_Messaging_Bots_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_work_0_badge(inputs)
	if (locale === "de") return de_svc_messaging_bots_work_0_badge(inputs)
	if (locale === "es") return es_svc_messaging_bots_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_work_0_badge(inputs)
	return en_svc_messaging_bots_work_0_badge(inputs)
});
export { svc_messaging_bots_work_0_badge as "svc_messaging-bots_work_0_badge" }